export default function pageScript() {
    // pagetop btn appears on scroll in the desktop version
    const topBtn = document.querySelector('.rwd002-pagetop');
    document.addEventListener('scroll', () => {
        if (window.scrollY >= 300 && window.screen.width >= 900) topBtn.style = 'opacity: 1; visibilty: visible';
        else if (window.scrollY < 300 && window.screen.width >= 900) topBtn.style = 'opacity: 0; visibility: hidden';
    })
}